// Define action types
export const SET_USERS_DATA = "SET_USERS_DATA";
export const SET_PAGINATED_USERS = "SET_PAGINATED_USERS";
export const SET_SEARCH = "SET_SEARCH";
export const SET_CUSTOM_PAGE = "SET_CUSTOM_PAGE";
export const SET_LOADING = "SET_LOADING";
export const SET_PER_PAGE = "SET_PER_PAGE";
export const SET_SORT_BY = "SET_SORT_BY";
export const SET_FILTERS = "SET_FILTERS";
export const DASHBOARD_CONTEXT = "DASHBOARD";
